import React, { useEffect, useState } from 'react';

import { CSSBlockPage } from '@core/constants';
import MotionCardToModal from '@motion/CardToModal';

interface Props {}

const Valuation: React.FC<Props> = ({}) => {
  const CSSBlock = 'valuation';

  return (
    <div className={`${CSSBlockPage} ${CSSBlock}`}>
      <div className={`${CSSBlockPage}__title`}>Jet Valuations</div>
      {/* <MotionCardToModal
        gridItems={[
          { id: '1', gridItem: <>a</>, modalItem: <>A</> },
          { id: '2', gridItem: <></>, modalItem: <></> },
        ]}
      /> */}
    </div>
  );
};

export default Valuation;
